import $ from 'jquery';
$('.video-grid .js--video-embed').on('click', function(e) {
	e.preventDefault();
})
